import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-process',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class AdmissionProcessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
